import type { SxProps, Theme } from '@mui/material';

/** Единый стиль текстовых полей в drawer'ах админки. */
export const fieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    fontSize: 13,
    '& fieldset': { borderColor: 'var(--color-border)' },
    '&:hover fieldset': { borderColor: 'var(--color-border-hover)' },
    '&.Mui-focused fieldset': { borderColor: 'var(--color-primary)' },
  },
  '& .MuiInputLabel-root': { fontSize: 13 },
  '& .MuiInputLabel-root.Mui-focused': { color: 'var(--color-primary)' },
};

/** Валидация email (используется в формах пользователей). */
export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
